import { render, staticRenderFns } from "./XRadio.vue?vue&type=template&id=185ea1c0"
import script from "./XRadio.vue?vue&type=script&lang=js"
export * from "./XRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports